<template>
    <!-- Redirect Modal -->
    <v-dialog
      v-model="showRedirectDialog"
      persistent
      max-width="500"
      max-height="500"
    >
      <v-card tile elevated>
        <v-toolbar elevated class="mb-4" color="primary">
        <v-toolbar-title>
          <v-card-title class="white--text">
            Order Grid has Moved!
        </v-card-title>
        </v-toolbar-title>
        </v-toolbar>

        <v-card-text class="black--text">
          Order Grid has moved to our new Alliance Retailer Site. Click below to be redirected. 
        </v-card-text>

        <v-card-actions class="justify-center pb-4">

          <!-- Button that redirects to new site -->
          <v-btn
            :href="newSiteUrl"
            color="primary"
            depressed
            class="mx-2"
          >
            Go to new site
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      showRedirectDialog: false,
      newSiteUrl: 'https://arg.partner.iprosystems.com/retail-manager'
    }
  },
  mounted () {
    // Show immediately on first load
    this.showRedirectDialog = true
  }
}
</script>
